const API = process.env.REACT_APP_API_URL || 'https://aldealix-backend-258966414953.europe-west1.run.app';

async function request(method, path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || 'Error del servidor');
    err.status = res.status;
    err.code = data.code || null;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  login: (email, password) => request('POST', '/api/auth/login', { email, password }),
  loginWithGoogle: (idToken) => request('POST', '/api/auth/google', { idToken }),
  register: (email, password) => request('POST', '/api/auth/register', { email, password }),
  requestAccess: (email) => request('POST', '/api/auth/access', { email }),
  requestMagicLink: (email) => request('POST', '/api/auth/magic-link', { email }),
  verifyMagicLink: (token, code, email) => request('POST', '/api/auth/magic-link/verify', { token, code, email }),
  me: (token) => request('GET', '/api/auth/me', null, token),
  changePassword: (token, currentPassword, newPassword) =>
    request('POST', '/api/auth/change-password', { currentPassword, newPassword }, token),
  setFirstPassword: (token, newPassword) =>
    request('POST', '/api/auth/set-first-password', { newPassword }, token),

  // Events
  getPublicEvents: (token) => request('GET', '/api/events', null, token),
  getAdminEvents: (token) => request('GET', '/api/admin/events', null, token),
  createEvent: (token, data) => request('POST', '/api/admin/events', data, token),
  updateEvent: (token, id, data) => request('PATCH', `/api/admin/events/${id}`, data, token),
  deleteEvent: (token, id) => request('DELETE', `/api/admin/events/${id}`, null, token),

  // Bookings
  createBooking: (token, data) => request('POST', '/api/bookings', data, token),
  myBookings: (token) => request('GET', '/api/bookings/my', null, token),
  verifyEventPassword: (token, eventId, password) => request('POST', '/api/bookings/verify-event-password', { eventId, password }, token),
  reactivateBooking: (token, id) => request('PATCH', `/api/bookings/${id}/reactivate`, {}, token),
  changePaymentPlan: (token, id, selectedPlan) => request('PATCH', `/api/bookings/${id}/payment-plan`, { selectedPlan }, token),
  myCampamentoReservas: (token) => request('GET', '/api/bookings/my-campamento', null, token),
  cancelBooking: (token, id) => request('PATCH', `/api/bookings/${id}/cancel`, {}, token),

  // Admin
  getStats: (token) => request('GET', '/api/admin/stats', null, token),
  getUsers: (token) => request('GET', '/api/admin/users', null, token),
  getUsersByEvent: (token, eventId) => request('GET', `/api/admin/users?eventId=${eventId}`, null, token),
  createFamilyUser: (token, data) => request('POST', '/api/admin/users/family', data, token),
  createAdminUser: (token, data) => request('POST', '/api/admin/users/admin', data, token),
  getAdminBookings: (token) => request('GET', '/api/admin/bookings', null, token),
  cancelAdminBooking: (token, id) => request('PATCH', `/api/admin/bookings/${id}/cancel`, {}, token),
  updateUser: (token, id, data) => request('PATCH', `/api/admin/users/${id}`, data, token),
  deleteUser: (token, id) => request('DELETE', `/api/admin/users/${id}`, null, token),
  updateBooking: (token, id, data) => request('PATCH', `/api/admin/bookings/${id}`, data, token),
  deleteBooking: (token, id) => request('DELETE', `/api/admin/bookings/${id}`, null, token),
  updateMyBooking: (token, id, members) => request('PATCH', `/api/bookings/${id}/members`, { members }, token),
  cancelMember: (token, id, memberIndex) => request('PATCH', `/api/bookings/${id}/cancel-member`, { memberIndex }, token),
  setExternalCount: (token, eventId, externalCount) => request('PATCH', `/api/admin/events/${eventId}/external-count`, { externalCount }, token),
  createAdminBooking: (token, data) => request('POST', '/api/bookings', { ...data, adminCreated: true }, token),
  refundBooking: (token, id, planId) => request('POST', `/api/admin/bookings/${id}/refund`, { planId }, token),
  markPaymentPaid: (token, bookingId, planId) => request('PATCH', `/api/admin/bookings/${bookingId}/mark-paid`, { planId }, token),
  changeBookingPaymentPlan: (token, bookingId, selectedPlan) => request('PATCH', `/api/admin/bookings/${bookingId}/payment-plan`, { selectedPlan }, token),
  getHospederias: (token, eventId) => request('GET', `/api/admin/events/${eventId}/hospederias`, null, token),
  getEventMembers: (token, eventId) => request('GET', `/api/admin/events/${eventId}/members`, null, token),
  getEventCampistas: (token, eventId) => request('GET', `/api/admin/events/${eventId}/campistas`, null, token),
  request: (method, path, body, token) => request(method, path, body, token),
  getDownloadUrl: (token, path) => request('GET', `/api/uploads/download-url/file?path=${encodeURIComponent(path)}`, null, token),

  // MotoPress (campamentoaldealix.com) — público, el token es el del enlace del
  // email (query param), no un Bearer de sesión.
  getMotopressReserva: (urlToken) => request('GET', `/api/motopress/reserva?token=${encodeURIComponent(urlToken)}`),
  completeMotopressReserva: (urlToken, personas) => request('POST', '/api/motopress/reserva/completar', { token: urlToken, personas }),
  payMotopressReserva: (urlToken, bus) => request('POST', '/api/motopress/reserva/pagar', { token: urlToken, bus }),
  // Autoservicio autorización de imagen (público, token del enlace).
  getImgConsent: (urlToken) => request('GET', `/api/motopress/imagen?token=${encodeURIComponent(urlToken)}`),
  saveImgConsent: (urlToken, cambios) => request('POST', '/api/motopress/imagen', { token: urlToken, cambios }),
  // Link de pago de reserva nativa (público, token del enlace).
  getNativePayLink: (urlToken) => request('GET', `/api/payments/link?token=${encodeURIComponent(urlToken)}`),
  payNativeLink: (urlToken) => request('POST', '/api/payments/link/pay', { token: urlToken }),
  // MotoPress — admin (Bearer de sesión)
  getAdminMotopressReservas: (token, estado) => request('GET', `/api/admin/motopress-reservas${estado ? `?estado=${estado}` : ''}`, null, token),
  deleteAdminMotopressReserva: (token, id) => request('DELETE', `/api/admin/motopress-reservas/${id}`, null, token),
  updateMotopressPago: (token, id, body) => request('PATCH', `/api/admin/motopress-reservas/${id}/pago`, body, token),
  sendMotopressEmail: (token, id) => request('POST', `/api/admin/motopress-reservas/${id}/email`, {}, token),
  sendMotopressEmailMasivo: (token, eventId) => request('POST', '/api/admin/motopress-reservas/email-masivo', { eventId }, token),
  sendMotopressEmailPagoPendiente: (token, eventId) => request('POST', '/api/admin/motopress-reservas/email-pago', { eventId }, token),
  createMotopressManual: (token, data) => request('POST', '/api/admin/motopress-reservas/manual', data, token),
  getAdminRoster: (token) => request('GET', '/api/admin/roster', null, token),
  getRosterExport: (token, eventId) => request('GET', `/api/admin/roster/export${eventId ? `?eventId=${eventId}` : ''}`, null, token),
  // Pago de reservas nativas (admin)
  updateNativePago: (token, id, body) => request('PATCH', `/api/admin/bookings/${id}/pago`, body, token),
  sendNativePayLinkEmail: (token, id) => request('POST', `/api/admin/bookings/${id}/pay-link-email`, {}, token),
  // Estancias de agosto (admin)
  createEstancia: (token, data) => request('POST', '/api/admin/estancias', data, token),
  getEstancias: (token) => request('GET', '/api/admin/estancias', null, token),
  assignEstancia: (token, id, email) => request('PATCH', `/api/admin/estancias/${id}/assign`, { email }, token),
  markEstanciaPlazo: (token, id, planId, paid) => request('PATCH', `/api/admin/estancias/${id}/plazo`, { planId, paid }, token),
  updateEstanciaAlojamiento: (token, id, body) => request('PATCH', `/api/admin/estancias/${id}/alojamiento`, body, token),
  // Alojamientos (Fase 3)
  getAlojamientos: (token) => request('GET', '/api/admin/alojamientos', null, token),
  createAlojamiento: (token, data) => request('POST', '/api/admin/alojamientos', data, token),
  updateAlojamiento: (token, id, body) => request('PATCH', `/api/admin/alojamientos/${id}`, body, token),
  deleteAlojamiento: (token, id) => request('DELETE', `/api/admin/alojamientos/${id}`, null, token),
  sendImgConsentEmail: (token, source, id) => request('POST', '/api/admin/img-consent/email', { source, id }, token),
  sendImgConsentEmailMasivo: (token, eventId) => request('POST', '/api/admin/img-consent/email-masivo', { eventId }, token),

  // Incidencias
  getIncidencias:    (token, eventId) => request('GET', `/api/admin/incidencias${eventId ? `?eventId=${eventId}` : ''}`, null, token),
  createIncidencia:  (token, data)    => request('POST', '/api/admin/incidencias', data, token),
  updateIncidencia:  (token, id, data)=> request('PATCH', `/api/admin/incidencias/${id}`, data, token),
  deleteIncidencia:  (token, id)      => request('DELETE', `/api/admin/incidencias/${id}`, null, token),

  // Admin Diario
  getDiarioAdmin:       (token, eventId) => request('GET', `/api/admin/diario${eventId ? `?eventId=${eventId}` : ''}`, null, token),
  createDiarioEntry:    (token, data)    => request('POST', '/api/admin/diario', data, token),
  updateDiarioEntry:    (token, id, data)=> request('PATCH', `/api/admin/diario/${id}`, data, token),
  deleteDiarioEntry:    (token, id)      => request('DELETE', `/api/admin/diario/${id}`, null, token),

  // Admin Autorizaciones
  getAutorizacionesAdmin: (token, eventId) => request('GET', `/api/admin/autorizaciones${eventId ? `?eventId=${eventId}` : ''}`, null, token),
  createAutorizacion:     (token, data)    => request('POST', '/api/admin/autorizaciones', data, token),
  updateAutorizacion:     (token, id, data)=> request('PATCH', `/api/admin/autorizaciones/${id}`, data, token),
  deleteAutorizacion:     (token, id)      => request('DELETE', `/api/admin/autorizaciones/${id}`, null, token),

  // Portal familia
  getPortalResumen:        (token) => request('GET', '/api/portal/resumen', null, token),
  getPortalDiario:         (token) => request('GET', '/api/portal/diario', null, token),
  getPortalAutorizaciones: (token) => request('GET', '/api/portal/autorizaciones', null, token),
  firmarAutorizacion:      (token, id) => request('POST', `/api/portal/autorizaciones/${id}/firmar`, {}, token),
  getPortalFichasSalud:    (token) => request('GET', '/api/portal/fichas-salud', null, token),

  // Personas
  getMyPersonas:     (token) => request('GET', '/api/personas', null, token),
  createPersona:     (token, data) => request('POST', '/api/personas', data, token),
  getPersona:        (token, id) => request('GET', `/api/personas/${id}`, null, token),
  updatePersona:     (token, id, data) => request('PATCH', `/api/personas/${id}`, data, token),
  deletePersona:     (token, id) => request('DELETE', `/api/personas/${id}`, null, token),
  createYoMismo:     (token, data) => request('POST', '/api/personas/yo-mismo', data, token),
  addRelacion:       (token, personaId, data) => request('POST', `/api/personas/${personaId}/relacion`, data, token),
  updateRelacion:    (token, personaId, data) => request('PATCH', `/api/personas/${personaId}/relacion`, data, token),
  removeRelacion:    (token, personaId) => request('DELETE', `/api/personas/${personaId}/relacion`, null, token),
  getAdminPersonas:  (token, search) => request('GET', `/api/admin/personas${search ? `?search=${encodeURIComponent(search)}` : ''}`, null, token),
  getAdminPersona:   (token, id) => request('GET', `/api/admin/personas/${id}`, null, token),

  // WhatsApp
  waGetLeads:       (token)              => request('GET',  '/api/whatsapp/leads', null, token),
  waConvertLead:    (token, phone, data) => request('POST', `/api/whatsapp/leads/${phone}/convert`, data, token),
  waGetMessages:    (token, phone)       => request('GET',  `/api/whatsapp/messages/${phone}`, null, token),
  waGetSession:     (token, phone)       => request('GET',  `/api/whatsapp/session/${phone}`, null, token),
  waSendMessage:    (token, phone, msg)  => request('POST', '/api/whatsapp/send', { phone, message: msg }, token),
};
